// extracted by mini-css-extract-plugin
module.exports = {"commonButton":"Button_commonButton__19MEh"};